import { Component } from '../../core/component.js';
import { store } from '../../store.js';
import { eventBus } from '../../events.js';
import { escapeHtml, userName, userInitials, formatPhone } from '../../core/utils.js';
import { hasAnyPermission, hasPlanAnyFeature, roleLabel } from '../../modules/auth/auth-service.js';

function isFreePlan() {
    const plan = store.plan;
    return plan && plan.slug === 'free';
}

const MENU_SECTIONS = [
    {
        items: [
            { path: '/',               key: 'dashboard',      label: 'Главная',        icon: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="2" y="2" width="7" height="7" rx="1"/><rect x="11" y="2" width="7" height="7" rx="1"/><rect x="2" y="11" width="7" height="7" rx="1"/><rect x="11" y="11" width="7" height="7" rx="1"/></svg>' },
            { path: '/pulse',          key: 'pulse',          label: 'Пульс',          perms: ['dashboard.view'], icon: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3 10h2l2-5 3 10 2-5h5"/></svg>' },
            { path: '/calendar',       key: 'calendar',       label: 'Календарь',      perms: ['calendar.view', 'calendar.view_own'], icon: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="2" y="3" width="16" height="15" rx="2"/><line x1="2" y1="8" x2="18" y2="8"/><line x1="6" y1="1" x2="6" y2="5"/><line x1="14" y1="1" x2="14" y2="5"/></svg>' },
        ],
    },
    {
        label: 'Бизнес',
        items: [
            { path: '/clients',        key: 'clients',        label: 'Клиенты',        perms: ['clients.view', 'clients.view_own'], icon: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="10" cy="7" r="3.5"/><path d="M3 17.5c0-3.5 3-6 7-6s7 2.5 7 6"/></svg>' },
            { path: '/visits',         key: 'visits',         label: 'Визиты',         perms: ['visits.view', 'visits.view_own'], icon: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M4 4h12v14H4z"/><path d="M7 8h6M7 11h6M7 14h4"/><path d="M8 2v3M12 2v3"/></svg>' },
            { path: '/staff',          key: 'staff',          label: 'Сотрудники',     perms: ['staff.view', 'staff.manage'], icon: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="7" cy="7" r="3"/><circle cx="14" cy="7" r="3"/><path d="M1 17c0-3 2.5-5 6-5s6 2 6 5"/><path d="M11 17c0-3 2-5 5-5s4 2 4 5"/></svg>' },
            { path: '/services',       key: 'services',       label: 'Услуги',         perms: ['services.view'], icon: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M10 2l2.5 5 5.5.8-4 3.9.9 5.5L10 14.7 5.1 17.2l.9-5.5-4-3.9 5.5-.8L10 2z"/></svg>' },
            { path: '/resources',      key: 'resources',      label: 'Ресурсы',        perms: ['resource.view'], plan: ['resource_booking'], icon: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="2" y="5" width="16" height="12" rx="2"/><path d="M2 9h16M7 5V3M13 5V3"/></svg>' },
            { path: '/groups',         key: 'groups',         label: 'Групповые',      perms: ['groups.view', 'groups.view_own'], plan: ['group_classes'], icon: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="6" cy="8" r="2.5"/><circle cx="14" cy="8" r="2.5"/><circle cx="10" cy="14" r="2.5"/><path d="M3 14v-1c0-1.5 1.3-2.5 3-2.5M17 14v-1c0-1.5-1.3-2.5-3-2.5"/></svg>' },
        ],
    },
    {
        label: 'Финансы',
        items: [
            { path: '/finance',        key: 'finance',        label: 'Финансы',        perms: ['finance.view'], plan: ['finance', 'finance_basic'], icon: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="2" y="4" width="16" height="12" rx="2"/><line x1="2" y1="9" x2="18" y2="9"/><circle cx="14" cy="13" r="1.5"/></svg>' },
            { path: '/salary',         key: 'salary',         label: 'Зарплаты',       perms: ['salary.view', 'salary.view_own'], plan: ['salary'], icon: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M10 2v16M6 6h8M7 10h6M8 14h4"/></svg>' },
            { path: '/warehouse',      key: 'warehouse',      label: 'Склад',          perms: ['warehouse.view'], plan: ['warehouse'], icon: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M2 8l8-5 8 5v9H2V8z"/><line x1="7" y1="17" x2="7" y2="11"/><line x1="13" y1="17" x2="13" y2="11"/><line x1="7" y1="11" x2="13" y2="11"/></svg>' },
            { path: '/loyalty',        key: 'loyalty',        label: 'Лояльность',     perms: ['loyalty.view'], plan: ['loyalty'], icon: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M10 4l1.5 3 3.5.5-2.5 2.5.6 3.5L10 12l-3.1 1.5.6-3.5L5 7.5l3.5-.5L10 4z"/><circle cx="10" cy="10" r="8"/></svg>' },
        ],
    },
    {
        label: 'Инструменты',
        items: [
            { path: '/analytics',      key: 'analytics',      label: 'Аналитика',      perms: ['analytics.view'], plan: ['analytics', 'analytics_basic'], icon: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="2" y="10" width="3" height="8" rx="0.5"/><rect x="7" y="6" width="3" height="12" rx="0.5"/><rect x="12" y="3" width="3" height="15" rx="0.5"/><rect x="17" y="8" width="1" height="10" rx="0.5"/></svg>' },
            { path: '/promotions',     key: 'promotions',     label: 'Акции',          perms: ['promotions.view', 'promotions.manage'], plan: ['promotions'], icon: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M17.5 10l-7.5 7.5L2.5 10 10 2.5 17.5 10z"/><circle cx="7" cy="7" r="1"/><circle cx="13" cy="13" r="1"/><path d="M7.5 12.5l5-5"/></svg>' },
            { path: '/online-booking', key: 'online-booking', label: 'Онлайн-запись',  perms: ['online_booking.manage'], plan: ['online_booking', 'online_booking_basic'], icon: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="10" cy="10" r="8"/><path d="M10 6v4l3 3"/></svg>' },
            { path: '/integrations',   key: 'integrations',   label: 'Интеграции',     perms: ['integrations.view'], plan: ['integrations'], icon: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="10" cy="10" r="3"/><path d="M10 2v5M10 13v5M18 10h-5M7 10H2"/><circle cx="10" cy="2" r="1"/><circle cx="10" cy="18" r="1"/><circle cx="18" cy="10" r="1"/><circle cx="2" cy="10" r="1"/></svg>' },
            { path: '/calls',          key: 'calls',          label: 'Звонки',         perms: ['calls.view'], plan: ['integrations'], icon: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3 4.5C3 3.67 3.67 3 4.5 3h2.38a1 1 0 01.97.75l.68 2.75a1 1 0 01-.56 1.12L6.4 8.38a10.5 10.5 0 005.22 5.22l.76-1.57a1 1 0 011.12-.56l2.75.68a1 1 0 01.75.97v2.38c0 .83-.67 1.5-1.5 1.5A13.5 13.5 0 013 4.5z"/></svg>' },
            { path: '/crm', key: 'crm', label: 'CRM', role: 'owner', plan: ['crm'], icon: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M14 2H6a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V4a2 2 0 00-2-2z"/><circle cx="10" cy="8" r="2.5"/><path d="M6 15c0-2 1.8-3.5 4-3.5s4 1.5 4 3.5"/></svg>' },
            { path: '/reports',        key: 'reports',        label: 'Отчёты',         perms: ['reports.view', 'settings.salon'], plan: ['reports'], icon: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M4 2h8l4 4v12a1 1 0 01-1 1H4a1 1 0 01-1-1V3a1 1 0 011-1z"/><path d="M12 2v4h4"/><path d="M7 10h6M7 13h4"/></svg>' },
            { path: '/reviews',        key: 'reviews',        label: 'Отзывы',         perms: ['settings.salon'], plan: ['reviews'], icon: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M10 2l2.24 4.54 5.01.73-3.63 3.53.86 4.99L10 13.27l-4.48 2.52.86-4.99L2.75 7.27l5.01-.73L10 2z"/></svg>' },
        ],
    },
    {
        items: [
            { path: '/support',        key: 'support',        label: 'Поддержка',      perms: ['support.manage'], icon: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="10" cy="10" r="8"/><path d="M7 7.5a3 3 0 015.5 1.5c0 2-3 2-3 4"/><circle cx="10" cy="15.5" r="0.5" fill="currentColor"/></svg>' },
            { path: '/settings',       key: 'settings',       label: 'Настройки',      icon: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="10" cy="10" r="3"/><path d="M10 1.5v2M10 16.5v2M18.5 10h-2M3.5 10h-2M16 4l-1.4 1.4M5.4 14.6L4 16M16 16l-1.4-1.4M5.4 5.4L4 4"/></svg>' },
            { path: '/billing',        key: 'billing',        label: 'Подписка',       icon: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="2" y="4" width="16" height="12" rx="2"/><line x1="2" y1="9" x2="18" y2="9"/><circle cx="14" cy="13" r="1.5"/></svg>' },
        ],
    },
];

// Flat list for exports (backwards compat)
const MENU_ITEMS = MENU_SECTIONS.flatMap(s => s.items);

export class Sidebar extends Component {
    constructor(props = {}) {
        super(props);
        this.el.className = 'app-sidebar';
        this.el.id = 'sidebar';
        this._unsubHash = null;
        this._pinned = localStorage.getItem('sidebar-pinned') !== 'false';
        this._missedCalls = [];
        this._crmTaskCount = 0;
        this._crmTaskOverdue = false;
        this._salaryWarnings = 0;
    }

    template() {
        const user = store.user;
        const currentPath = (window.location.hash.slice(1) || '/').split('?')[0];

        const freePlan = isFreePlan();

        const menuHtml = MENU_SECTIONS.map((section, si) => {
            const visibleItems = section.items.filter(item => {
                if (item.perms && !hasAnyPermission(...item.perms)) return false;
                if (item.role && store.account?.role !== item.role) return false;
                // Show plan-gated items as locked instead of hiding
                return true;
            });
            if (!visibleItems.length) return '';

            const itemsHtml = visibleItems.map(item => {
                const isLocked = item.plan && !hasPlanAnyFeature(...item.plan);
                const isActive = !isLocked && (item.path === '/'
                    ? currentPath === '/'
                    : currentPath.startsWith(item.path));
                const isBillingHighlight = item.key === 'billing' && freePlan;

                let cls = 'sidebar-link';
                if (isActive) cls += ' active';
                if (isLocked) cls += ' sidebar-link--locked';
                if (isBillingHighlight) cls += ' sidebar-link--highlight';

                const badge = isLocked ? '<span class="sidebar-pro-badge">PRO</span>' : '';
                const pulseDot = isBillingHighlight ? '<span class="sidebar-pulse-dot"></span>' : '';

                if (isLocked) {
                    return `
                        <a href="javascript:void(0)" class="${cls}" data-path="${item.path}" data-locked="${item.key}" title="${item.label}">
                            <span class="sidebar-icon">${item.icon}</span>
                            <span class="sidebar-label">${item.label}</span>
                            ${badge}
                        </a>
                    `;
                }

                const crmBadge = item.key === 'crm' && this._crmTaskCount > 0
                    ? `<span class="sidebar-badge ${this._crmTaskOverdue ? 'sidebar-badge--danger' : ''}">${this._crmTaskCount}</span>`
                    : '';

                const salaryBadge = item.key === 'salary' && this._salaryWarnings > 0
                    ? `<span class="sidebar-badge sidebar-badge--danger">${this._salaryWarnings}</span>`
                    : '';

                return `
                    <a href="#${item.path}" class="${cls}" data-path="${item.path}" title="${item.label}">
                        <span class="sidebar-icon">${item.icon}</span>
                        <span class="sidebar-label">${item.label}</span>
                        ${crmBadge}${salaryBadge}${pulseDot}
                    </a>
                `;
            }).join('');

            const sectionLabel = section.label
                ? `<div class="sidebar-section-label">${section.label}</div>`
                : (si > 0 ? '<div class="sidebar-divider"></div>' : '');

            return `${sectionLabel}${itemsHtml}`;
        }).join('');

        const displayName = user ? escapeHtml(userName(user)) : '';
        const initials = user ? userInitials(user) : '';
        const account = store.account;
        const branch = store.branch;
        const accountId = account?.account_id || account?.id || '';
        const branchId = branch?.id || '';
        const roleName = roleLabel();
        const idBadge = accountId ? `<span class="sidebar-account-id" title="Аккаунт #${accountId}${branchId ? `, филиал #${branchId}` : ''}">#${accountId}${branchId ? `/${branchId}` : ''}</span>` : '';
        const userBlock = user ? `
            <a href="#/settings?tab=profile" class="sidebar-user" id="sidebarUser">
                <div class="sidebar-user-avatar">${initials}</div>
                <div class="sidebar-user-info">
                    <div class="sidebar-user-name">${displayName}${idBadge}</div>
                    ${roleName ? `<div class="sidebar-user-role">${roleName}</div>` : ''}
                </div>
                <button class="sidebar-logout" id="sidebarLogout" title="Выйти">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.5">
                        <path d="M6 15H3a1 1 0 01-1-1V4a1 1 0 011-1h3M12 12l3-3-3-3M7 9h8"/>
                    </svg>
                </button>
            </a>
        ` : '';

        const pinIcon = this._pinned
            ? '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M15 9H3"/><path d="M9 15l-6-6 6-6"/></svg>'
            : '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3 9h12"/><path d="M9 3l6 6-6 6"/></svg>';

        const activeBranchId = store.branch?.id || null;
        const filteredMissed = activeBranchId
            ? this._missedCalls.filter(c => c.branchId === activeBranchId)
            : this._missedCalls;

        const missedHtml = filteredMissed.length ? `
            <div class="sidebar-missed-calls">
                <div class="sidebar-missed-header">
                    <span class="sidebar-missed-title">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"/></svg>
                        <span class="sidebar-label">Пропущенные (${filteredMissed.length})</span>
                    </span>
                    <button class="sidebar-missed-clear" data-action="clear-missed" title="Очистить">×</button>
                </div>
                ${filteredMissed.map(c => `
                    <div class="sidebar-missed-item" data-call-id="${c.id}">
                        <span class="sidebar-missed-phone">${escapeHtml(formatPhone(c.phone))}</span>
                        <span class="sidebar-missed-meta">${c.clientName ? escapeHtml(c.clientName) : ''} ${c.time}</span>
                    </div>
                `).join('')}
            </div>
        ` : '';

        return `
            <div class="sidebar-logo">
                <span class="sidebar-logo-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="var(--color-primary)" stroke="none">
                        <rect x="3" y="3" width="8" height="8" rx="2"/>
                        <rect x="13" y="3" width="8" height="8" rx="2" opacity="0.6"/>
                        <rect x="3" y="13" width="8" height="8" rx="2" opacity="0.6"/>
                        <rect x="13" y="13" width="8" height="8" rx="2" opacity="0.3"/>
                    </svg>
                </span>
                <span class="sidebar-logo-text">BWClients</span>
            </div>
            <nav class="sidebar-nav">
                <button class="sidebar-pin-link" id="sidebarPinBtn" title="${this._pinned ? 'Свернуть меню' : 'Развернуть меню'}">
                    <span class="sidebar-icon">${pinIcon}</span>
                    <span class="sidebar-label">${this._pinned ? 'Свернуть' : 'Развернуть'}</span>
                </button>
                ${menuHtml}
            </nav>
            ${missedHtml}
            ${userBlock}
        `;
    }

    afterRender() {
        const logoutBtn = this.el.querySelector('#sidebarLogout');
        if (logoutBtn) {
            logoutBtn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                eventBus.emit('auth:logout');
            });
        }

        // Locked items → show upgrade prompt
        this.el.querySelectorAll('[data-locked]').forEach(link => {
            link.addEventListener('click', async (e) => {
                e.preventDefault();
                const { showUpgradePrompt } = await import('../ui/upgrade-prompt.js');
                showUpgradePrompt(link.dataset.locked);
            });
        });

        // Close sidebar on mobile when navigating
        this.el.querySelectorAll('.sidebar-link:not([data-locked])').forEach(link => {
            link.addEventListener('click', () => {
                if (window.innerWidth < 768) {
                    this.close();
                    eventBus.emit('sidebar:close');
                }
            });
        });

        // Pin/collapse toggle
        const pinBtn = this.el.querySelector('#sidebarPinBtn');
        if (pinBtn) {
            pinBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                this._pinned = !this._pinned;
                localStorage.setItem('sidebar-pinned', this._pinned);
                document.body.classList.toggle('sidebar-collapsed', !this._pinned);
                this.render();
            });
        }

        // Apply collapsed state
        if (!this._pinned && window.innerWidth > 767) {
            document.body.classList.add('sidebar-collapsed');
        }

        // Clear missed calls button
        const clearBtn = this.el.querySelector('[data-action="clear-missed"]');
        if (clearBtn) {
            clearBtn.addEventListener('click', async (e) => {
                e.preventDefault();
                const { clearAllMissedCalls } = await import('../../modules/integrations/call-popup.js');
                clearAllMissedCalls();
            });
        }

        // Open call popup on click, then remove from missed
        this.el.querySelectorAll('.sidebar-missed-item').forEach(item => {
            item.addEventListener('click', async (e) => {
                e.preventDefault();
                const callId = item.dataset.callId;

                // Remove from missed list immediately
                if (callId) {
                    const { clearMissedCall } = await import('../../modules/integrations/call-popup.js');
                    clearMissedCall(callId);
                }

                if (window.innerWidth < 768) {
                    this.close();
                    eventBus.emit('sidebar:close');
                }

                // Fetch full call data and show call popup
                if (callId) {
                    try {
                        const { integrationsService } = await import('../../modules/integrations/integrations-service.js');
                        const call = await integrationsService.getCall(callId);
                        if (call) {
                            const { showCallPopup } = await import('../../modules/integrations/call-popup.js');
                            showCallPopup({
                                call_id: call.id,
                                branch_id: call.branch_id,
                                caller_number: call.caller_number,
                                callee_number: call.callee_number,
                                started_at: call.started_at,
                                status: call.status,
                                recording_url: call.recording_url || null,
                                transcription: call.transcription || null,
                                transcription_status: call.transcription_status || null,
                                client: call.client || null,
                            }, { source: 'call-log' });
                        }
                    } catch (err) {
                        console.error('Failed to load call details', err);
                    }
                }
            });
        });
    }

    mount(container) {
        super.mount(container);

        this._unsubHash = () => this.render();
        window.addEventListener('hashchange', this._unsubHash);

        this._unsubUser = store.subscribe('user', () => this.render());
        this._unsubPlan = store.subscribe('plan', () => this.render());
        this._unsubBranch = store.subscribe('branch', () => this.render());

        this._unsubMissed = eventBus.on('calls:missed', (calls) => {
            this._missedCalls = calls;
            this.render();
        });

        // CRM task badge (OWNER only)
        if (store.account?.role === 'owner') {
            this._loadCrmTaskStats();
            this._unsubCrmTasks = eventBus.on('crm:tasks-changed', () => this._loadCrmTaskStats());
        }

        // Salary warnings badge
        if (hasAnyPermission('salary.view', 'salary.view_own')) {
            this._loadSalaryWarnings();
            this._unsubSalaryRefresh = eventBus.on('salary:changed', () => this._loadSalaryWarnings());
        }

        // Apply initial collapsed state
        if (!this._pinned && window.innerWidth > 767) {
            document.body.classList.add('sidebar-collapsed');
        }

        return this;
    }

    async _loadCrmTaskStats() {
        try {
            const { api } = await import('../../api.js');
            const stats = await api.get('/personal/tasks/stats');
            const open = stats?.open ?? 0;
            const overdue = stats?.overdue ?? 0;
            if (open !== this._crmTaskCount || (overdue > 0) !== this._crmTaskOverdue) {
                this._crmTaskCount = open;
                this._crmTaskOverdue = overdue > 0;
                this.render();
            }
        } catch { /* non-critical */ }
    }

    async _loadSalaryWarnings() {
        try {
            const { api } = await import('../../api.js');
            const res = await api.get('/salary/warnings');
            const count = res?.count ?? 0;
            if (count !== this._salaryWarnings) {
                this._salaryWarnings = count;
                this.render();
            }
        } catch { /* non-critical — plan may not include salary */ }
    }

    destroy() {
        if (this._unsubHash) {
            window.removeEventListener('hashchange', this._unsubHash);
        }
        if (this._unsubUser) this._unsubUser();
        if (this._unsubPlan) this._unsubPlan();
        if (this._unsubBranch) this._unsubBranch();
        if (this._unsubMissed) this._unsubMissed();
        if (this._unsubCrmTasks) this._unsubCrmTasks();
        if (this._unsubSalaryRefresh) this._unsubSalaryRefresh();
        document.body.classList.remove('sidebar-collapsed');
        super.destroy();
    }

    open() {
        this.el.classList.add('is-open');
    }

    close() {
        this.el.classList.remove('is-open');
    }

    toggle() {
        this.el.classList.toggle('is-open');
    }
}

export { MENU_ITEMS };
